import track from './track'

$(".cta-orders .btn, .cta-orders .trigger").click(e => {
    let method = document.querySelector('body').dataset.method ?? null
    let controller = document.querySelector('body').dataset.controller ?? null
    let locale = document.querySelector('html').getAttribute('lang') ?? null
    let label = (controller && method && locale) ? `${controller}-${method}-${locale}` : null

    track.event({
        eventCategory: "orders",
        eventAction: "access",
        eventLabel: label
    })
})
